<template>
  <el-main>
    <h3 class="section-title green-left-head">申込抽選管理</h3>
    <el-descriptions title="基本情報" :column="1">
      <el-descriptions-item label="名称">{{
        allocation.name
      }}</el-descriptions-item>
      <el-descriptions-item label="タイプ">{{
        allocation.type
      }}</el-descriptions-item>
      <el-descriptions-item label="期間"
        >{{ allocation.reception_range[0] | moment("YYYY-MM-DD") }} 〜
        {{
          allocation.reception_range[1] | moment("YYYY-MM-DD")
        }}</el-descriptions-item
      >
    </el-descriptions>
    <el-divider></el-divider>
    <el-radio-group v-model="lottery.status" @change="onChangeStatus">
      <el-radio :label="item" v-for="item in statuses" :key="item"></el-radio>
    </el-radio-group>
    <el-divider></el-divider>
    <el-row>
      <el-tooltip
        class="item"
        effect="dark"
        content="抽選を行うと保存されます"
        placement="top-start"
      >
        <el-button @click="onShuffle" :disabled="isPublic">抽選</el-button>
      </el-tooltip>
      <el-button @click="onReset" :disabled="isPublic">抽選リセット</el-button>
      <el-button @click="onLottery">割付</el-button>
      <!-- <el-tooltip
        class="item"
        effect="dark"
        content="抽選中、抽選結果公開時のみ保存可"
        placement="top-start">
        <el-button @click="onSaveLottery" :disabled="!canSave">保存</el-button>
      </el-tooltip> -->
      <el-button @click="onExportLottery">申込状況ダウンロード</el-button>
      <!-- <el-button @click="onDffBlock">空きブロック</el-button> -->
      <div class="last-lottery">
        最終抽選日時({{
          lottery.lastLotteryDate | moment("YYYY-MM-DD HH:mm:ss")
        }})
      </div>
    </el-row>
    <el-divider></el-divider>
    <el-tabs
      v-model="no"
      @tab-click="onSelectCarNo"
      v-if="allocation.type != 'フリー'"
    >
      <el-tab-pane label="1台目"></el-tab-pane>
      <el-tab-pane label="2台目"></el-tab-pane>
      <el-tab-pane label="3台目"></el-tab-pane>
    </el-tabs>
    <el-divider>抽選</el-divider>
    <el-table
      :data="lottery.normalizedEntries[no]"
      stripe
      style="width: 100%"
      max-height="500"
    >
      <el-table-column
        label="部屋番号"
        prop="roomNo"
        :sort-method="test"
        width="100"
        sortable
        fixed
      ></el-table-column>
      <el-table-column
        label="申込"
        prop="entry"
        sortable
        :filters="[{ text: '申込のみ', value: true }]"
        :filter-method="filterHandler"
        align="center"
        fixed
        ><template slot-scope="scope">
          <div v-if="scope.row.entry">◯</div>
          <div v-else>-</div>
        </template></el-table-column
      >
      <el-table-column label="優先順位" prop="priority" sortable fixed>
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.priority"
            placeholder="Select"
            @change="onChange(scope.row.roomNo, scope.row.priority)"
            :disabled="scope.row.entry == null || scope.row.isFixed || isPublic"
          >
            <el-option
              v-for="item in priorityOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="
                fixedPriorities.findIndex(obj => obj.priority === item.value) !=
                  -1
              "
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="順位固定"
        prop="isFixed"
        align="center"
        sortable
        fixed
      >
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row.isFixed"
            @change="onChangeFix"
            :disabled="scope.row.entry == null || isPublic"
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(block, index) in blocks[no]"
        :key="index"
        :label="index"
        :prop="index"
        sortable
      >
        <template slot-scope="scope">
          <div v-if="scope.row[index] && scope.row[index] < 99999">
            {{ scope.row[index] }}
          </div>
          <div v-else-if="scope.row[index] && scope.row[index] == 99999">
            不要
          </div>
          <div v-else-if="scope.row[index] && scope.row[index] == 999999">
            不可
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>

    <el-button @click="$router.go(-1)">戻る</el-button>
  </el-main>
</template>

<script>
import AllocationService from "@/services/allocation.service";
import AllocationAreaService from "@/services/allocation-area.service";
import AllocationEntryService from "@/services/allocation-entry.service";
import AllocationLotteryService from "@/services/allocation-lottery.service";
import UserService from "@/services/user.service";
import Admin from "../../../../mixin/guard/admin";
import _ from "lodash";
import moment from "moment";

const defaultLottery = {
  _id: null,
  allocation: null,
  no: "1",
  normalizedEntries: [[], [], []], //
  results: {},
  status: "非公開",
  lastLotteryDate: null,
};

export default {
  name: "ApplicationLottery",
  mixins: [Admin],
  data() {
    return {
      // randomSeed: "1234",
      priorities: [],
      allocation: { reception_range: [new Date(), new Date()] },
      users: [],
      entries: [[], [], []],
      // normalizedEntries: [],
      blocks: [[], [], []],
      results: [{}, {}, {}],
      priorityOptions: [],
      fixedPriorities: [],
      resultsByRoom: [],
      resultsByBlock: [],
      no: "0",
      lottery: _.cloneDeep(defaultLottery),
      statuses: [],
      lastLottery: null,
    };
  },
  computed: {
    currentNormalizedEntries() {
      console.log("currentNormalizedEntries", this.lottery.normalizedEntries);
      return this.lottery.normalizedEntries[this.no];
    },
    isPublic() {
      return this.lottery.status == "公開";
    },
    canSave() {
      return ["抽選中", "抽選結果公開"].includes(this.allocation.status);
    },
  },
  watch: {
    "lottery.normalizedEntries": {
      handler: function(val, oldVal) {
        console.log("lottery", val);
        console.log("oldVal", oldVal);
        // this.initResultsByRoomNo();
        // this.initResultsByBlock();
      },
      deep: true,
    },
  },
  async mounted() {
    console.log("mounted", this.$route.params.allocation_id, this.no);
    await this.loadAllocationLotteryStatuses();
    await this.loadAllocation(this.$route.params.allocation_id);
    await this.loadEntriesByNo(this.$route.params.allocation_id, 0);
    await this.loadEntriesByNo(this.$route.params.allocation_id, 1);
    await this.loadEntriesByNo(this.$route.params.allocation_id, 2);
    await this.loadUsersInMansion();
    await this.loadAllocationArea(this.$route.params.allocation_id);
    // this.createNormalEntries(0);
    // this.createNormalEntries(1);
    // this.createNormalEntries(2);
    this.initResults();

    // 抽選情報の取得
    await this.loadLotteryByAllocationID(this.$route.params.allocation_id);
    this.createNormalEntries(0);
    this.createNormalEntries(1);
    this.createNormalEntries(2);
    this.resetFixedPriorities(this.no);
    this.resetPriorityOptions();

    // console.log("this.no", this.no);
    console.log(
      "6this.normalizedEntries1",
      _.cloneDeep(this.lottery.normalizedEntries),
    );
  },
  methods: {
    async onReset() {
      console.log("onReset", this.lottery);
      if (!confirm("抽選データをリセットしますか？")) {
        return;
      }
      if (this.lottery._id) {
        const response = await AllocationLotteryService.delete(
          this.lottery._id,
        );
        console.log("response", response);
        this.lottery._id = null;
      }
      this.createNormalEntries(0);
      this.createNormalEntries(1);
      this.createNormalEntries(2);
      this.initResults();
      this.resetFixedPriorities(this.no);
      this.resetPriorityOptions();
      console.log("this.lottery", this.lottery);
    },
    async onChangeStatus() {
      console.log("onChangeStatus", this.lottery.status);
      await this.onSaveLottery();
    },
    // ステータスの取得
    async loadAllocationLotteryStatuses() {
      console.log("loadAllocationLotteryStatuses");
      const response = await AllocationLotteryService.getStatuses();
      // console.log("response", response);
      this.statuses = response;
    },
    // 抽選情報の取得
    async loadLotteryByAllocationID(allocation_id) {
      console.log("loadLotteryByAllocationID", allocation_id);
      const response = await AllocationLotteryService.find({
        where: {
          allocation: allocation_id,
        },
      });
      if (response.data && response.data.length > 0) {
        console.log("response.data", response.data);
        this.lottery = response.data[0];
        // this.lastLotteryDate = this.lottery.lastLotteryDate;
      }
      console.log("response", response);

      console.log(
        "11.normalizedEntries1",
        _.cloneDeep(this.lottery.normalizedEntries),
      );
    },
    async onSaveLottery() {
      console.log("onSaveLottery");
      console.log("normalizedEntries", this.lottery.normalizedEntries);
      if (this.lottery._id) {
        console.log("update");
        const response = await AllocationLotteryService.update(this.lottery);
        console.log("onSaveLottery:response", response);
        // this.lastLotteryDate = response.data.lastLotteryDate;
      } else {
        console.log("create");
        this.lottery.allocation = this.allocation._id;
        console.log("this.lottery", this.lottery);
        const response = await AllocationLotteryService.create(this.lottery);
        console.log("onSaveLottery:response", response);
        // this.lastLotteryDate = response.data.lastLotteryDate;
      }
      this.$message({
        type: "success",
        message: "保存しました",
      });
    },
    async onSelectCarNo() {
      console.log("onSelectCarNo", this.no);
      console.log(
        "this.lottery.normalizedEntries",
        _.cloneDeep(this.lottery.normalizedEntries),
      );
      this.resetFixedPriorities(this.no);
      this.resetPriorityOptions();
    },
    initResultsByBlock() {
      this.resultsByBlock = [];
      for (const key in this.results[this.no]) {
        if (Object.hasOwnProperty.call(this.results[this.no], key)) {
          const element = this.results[this.no][key];
          let obj = {
            block: key,
          };
          let rooms = [];
          for (const key2 in element) {
            if (Object.hasOwnProperty.call(element, key2)) {
              const obj2 = element[key2];
              rooms.push(obj2 ? `${obj2.roomNo}(${obj2.entry.no + 1})` : "");
            }
          }
          obj.rooms = rooms;
          this.resultsByBlock.push(obj);
        }
      }
      console.log("resultsByBlock=", this.resultsByBlock);
    },
    initResultsByRoomNo() {
      this.resultsByRoom = [];
      for (const key in this.results[this.no]) {
        if (Object.hasOwnProperty.call(this.results[this.no], key)) {
          const element = this.results[this.no][key];
          for (const key2 in element) {
            if (Object.hasOwnProperty.call(element, key2)) {
              const obj = element[key2];
              this.resultsByRoom.push({
                block: key,
                no: key2,
                roomNo: obj ? obj.roomNo : "",
                entry: obj,
              });
            }
          }
        }
      }
      console.log("resultsByRoom=", this.resultsByRoom);
    },
    onChangeFix() {
      console.log("onChangeFix");
      this.resetFixedPriorities(this.no);
      this.resetPriorityOptions();
    },
    resetFixedPriorities(no) {
      console.log("resetFixedPriorities", no);
      console.log(
        "this.lottery.normalizedEntries",
        _.cloneDeep(this.lottery.normalizedEntries),
      );
      this.fixedPriorities = [];
      for (
        let index = 0;
        index < this.lottery.normalizedEntries[no].length;
        index++
      ) {
        const normalEntry = this.lottery.normalizedEntries[no][index];
        if (normalEntry.isFixed) {
          this.fixedPriorities.push({
            priority: normalEntry.priority,
            roomNo: normalEntry.roomNo,
          });
        }
      }
      console.log("fixedPriorities", this.fixedPriorities);
    },
    getFixedPriorities(no) {
      console.log("getFixedPriorities", no);
      console.log(
        "this.lottery.normalizedEntries",
        _.cloneDeep(this.lottery.normalizedEntries),
      );
      let fps = [];
      for (
        let index = 0;
        index < this.lottery.normalizedEntries[no].length;
        index++
      ) {
        const normalEntry = this.lottery.normalizedEntries[no][index];
        if (normalEntry.isFixed) {
          fps.push({
            priority: normalEntry.priority,
            roomNo: normalEntry.roomNo,
          });
        }
      }
      console.log("fps=", fps);
      return fps;
    },
    async onChange(roomNo, value) {
      console.log("onChange", roomNo, value);
      console.log("entries", this.entries);
      console.log("normalizedEntries", this.lottery.normalizedEntries);
      console.log("fixedPriorities", this.fixedPriorities);
      // 変更した値と固定値をキープする
      let keepPriorities = [{ priority: value, roomNo }];
      for (let index = 0; index < this.fixedPriorities.length; index++) {
        const fixedPriority = this.fixedPriorities[index];
        keepPriorities.push(_.cloneDeep(fixedPriority));
      }
      console.log("keepPriorities", keepPriorities);
      // 固定以外のエントリーを取得する
      const otherEntries = await this.lottery.normalizedEntries[this.no].filter(
        entry => {
          return (
            keepPriorities.findIndex(item => item.roomNo == entry.roomNo) ==
              -1 && entry.priority != null
          );
        },
      );
      await otherEntries.sort((a, b) => {
        return a.priority - b.priority;
      });
      console.log("otherEntries", otherEntries);

      // キープを除いたプライオリティリストを生成する
      const allPriorities = Array.from(
        { length: this.entries[this.no].length },
        (_, index) => index + 1,
      );
      console.log("allPriorities", allPriorities);
      const newPriorities = await allPriorities.filter(
        item => !keepPriorities.map(obj => obj.priority).includes(item),
      );
      console.log("newPriorities", newPriorities);

      for (let index = 0; index < newPriorities.length; index++) {
        const newPriority = newPriorities[index];
        const otherEntry = otherEntries[index];
        console.log("otherEntry", otherEntry);
        const normalEntry = this.lottery.normalizedEntries[this.no].find(
          entry => {
            console.log("---", entry);
            console.log("+++", entry.roomNo);
            return entry.roomNo == otherEntry.roomNo;
          },
        );
        normalEntry.priority = newPriority;
      }
      console.log("normalizedEntries", this.lottery.normalizedEntries);
    },
    resetNormalEntries(roomNo, value) {
      this.lottery.normalizedEntries.map(entry => {
        if (entry.roomNo != roomNo) {
          if (entry.priority <= value) {
            entry.priority--;
          } else if (entry.priority < value) {
            entry.priority++;
          }
        }
      });
    },
    rearrangeArray(arr, sourceIndex, targetIndex) {
      if (sourceIndex === targetIndex) return arr; // 位置が同じ場合は何もしない

      const elementToMove = arr[sourceIndex];

      if (sourceIndex < targetIndex) {
        // 右に移動する場合
        for (let i = sourceIndex; i < targetIndex; i++) {
          arr[i] = arr[i + 1];
        }
      } else {
        // 左に移動する場合
        for (let i = sourceIndex; i > targetIndex; i--) {
          arr[i] = arr[i - 1];
        }
      }

      arr[targetIndex] = elementToMove;

      return arr;
    },
    async onShuffle() {
      console.log("onShuffle");
      console.log("申し込み:normalizedEntries", this.lottery.normalizedEntries);
      if (!confirm("最新の申し込み情報で抽選します。よろしいですか？")) {
        return;
      }

      this.lottery.lastLotteryDate = new Date();
      for (let daiIndex = 0; daiIndex < 3; daiIndex++) {
        const fps = this.getFixedPriorities(daiIndex);
        console.log("固定:fps", fps);
        let keepPriorities = [];
        for (let index = 0; index < fps.length; index++) {
          const fixedPriority = fps[index];
          keepPriorities.push(_.cloneDeep(fixedPriority));
        }
        console.log("順位固定:keepPriorities", keepPriorities);

        const allPriorities = Array.from(
          { length: this.entries[daiIndex].length },
          (_, index) => index + 1,
        ).filter(
          item => !keepPriorities.map(obj => obj.priority).includes(item),
        );
        console.log("固定以外:allPriorities", allPriorities);

        const priorities = _.shuffle(allPriorities);
        console.log("固定以外をシャフル:priorities=", priorities);

        // 全エントリーのループ
        let counter = 0;
        for (
          let index = 0;
          index < this.lottery.normalizedEntries[daiIndex].length;
          index++
        ) {
          const normalizedEntry = this.lottery.normalizedEntries[daiIndex][
            index
          ];
          // エントリーがある場合
          if (normalizedEntry.entry != null) {
            const incEntry = keepPriorities.find(
              obj => obj.roomNo == normalizedEntry.roomNo,
            );
            console.log("固定に含まれる:incEntry", incEntry);
            if (!incEntry) {
              console.log("index=", index);
              console.log("normalizedEntry=", normalizedEntry);
              normalizedEntry.priority = priorities[counter];
              counter++;
            }
          }
        }
      }

      console.log(
        "順位付きエントリー:normalizedEntries",
        this.lottery.normalizedEntries,
      );
      await this.onSaveLottery();
    },
    onLottery: async function() {
      console.log("割付:onLottery");
      await this.onSaveLottery();
      this.$router.push({
        name: "admin-allocation-lottery-result",
        params: { allocation_id: this.$route.params.allocation_id },
      });
    },
    initResults() {
      this.results[this.no] = {};
      for (const key in this.blocks[this.no]) {
        if (Object.hasOwnProperty.call(this.blocks[this.no], key)) {
          const block = this.blocks[this.no][key];
          this.results[this.no][key] = {};
          for (let index = 0; index < block.no.length; index++) {
            const no = block.no[index];
            this.results[this.no][key][no] = null;
          }
        }
      }
      console.log("results=", this.results[this.no]);
    },
    // eslint-disable-next-line
    filterHandler(value, row, column) {
      // console.log("filterHandler", value, row, column);
      return row["entry"] != null;
    },

    test: function(a, b) {
      let index = 0;
      let a_num = parseInt(a);
      let b_num = parseInt(b);

      if (a_num > b_num) {
        index = 1;
      } else if (a_num < b_num) {
        index = -1;
      }
      return index;
    },
    createNormalEntries(no) {
      let temp = [];
      for (let index = 0; index < this.entries[no].length; index++) {
        temp.push(index + 1);
      }
      const normalizedEntriesCopy = _.cloneDeep(
        this.lottery.normalizedEntries[no],
      );
      console.log("normalizedEntriesCopy=", normalizedEntriesCopy);
      this.$set(this.lottery.normalizedEntries, no, []);
      // let counter = 0;
      let maxPriority = 0;
      for (let index = 0; index < this.users.length; index++) {
        const user = this.users[index];
        const entry = this.entries[no].find(entry => entry.user == user._id);
        const oldEntry = normalizedEntriesCopy.find(
          entry => entry.roomNo == user.roomNo,
        );
        // console.log("entry=", index, no, entry, user);
        const obj = {
          roomNo: user.roomNo,
          priority: oldEntry ? oldEntry.priority : null,
          isFixed: oldEntry ? oldEntry.isFixed : null,
        };

        if (oldEntry && oldEntry.priority) {
          maxPriority++;
        }
        const keys = Object.keys(this.blocks[no]);
        // console.log("keys=", keys);
        if (entry) {
          for (let index2 = 0; index2 < keys.length; index2++) {
            const key = keys[index2];
            obj[key] = entry.entries[key];
            obj.entry = entry;
          }
          // obj.priority = counter + 1;
          // console.log("obj=", no, index, obj);
          // counter++;
        } else {
          for (let index2 = 0; index2 < keys.length; index2++) {
            const key = keys[index2];
            obj[key] = null;
            obj.entry = null;
          }
        }
        // console.log("obj_1=", no, index, obj);
        this.lottery.normalizedEntries[no].push(obj);
      }
      console.log("normalizedEntries1=", this.lottery.normalizedEntries[no]);
      console.log("maxPriority=", maxPriority);
      let counter = maxPriority + 1;
      for (
        let index = 0;
        index < this.lottery.normalizedEntries[no].length;
        index++
      ) {
        const element = this.lottery.normalizedEntries[no][index];
        // console.log("element=", element);
        if (element.entry != null && element.priority == null) {
          // console.log("element=", element);
          element.priority = counter;
          counter++;
        }
      }
      this.resetPriorityOptions();
    },
    resetPriorityOptions() {
      this.priorityOptions = [];
      for (let index = 0; index < this.entries[this.no].length; index++) {
        this.priorityOptions.push({
          label: index + 1,
          value: index + 1,
        });
      }
      console.log("priorityOptions=", this.priorityOptions);
    },
    // マンションの住人を取得
    async loadUsersInMansion() {
      console.log("loadUsersInMansion");
      const response = await UserService.findAtMansion({
        option: {
          sort: { roomNo: 1 },
          select: "roomNo",
        },
        collation: {
          locale: "en",
          numericOrdering: true,
        },
      });
      this.users = response.data;
      // console.log("this.users", this.users);
    },
    // Allocationの取得
    async loadAllocation(allocation_id) {
      console.log("loadAllocation");
      const response = await AllocationService.findByID(allocation_id);
      this.allocation = response.data;
      console.log("this.allocation", this.allocation);
    },
    // no台目のAllocationEntryを取得
    async loadEntriesByNo(allocation_id, no) {
      console.log("loadEntriesByNo", no);
      const response = await AllocationEntryService.find({
        where: {
          allocation: allocation_id,
          no: no,
        },
        option: {
          sort: { no: 1 },
        },
      });
      this.$set(this.entries, no, response.data);
      // this.entries[no] = response.data;
      console.log("entries=", no, this.entries[no]);
    },
    onSubmit() {
      console.log("submit!");
    },
    // AllocationAreaの取得
    async loadAllocationArea(allocation_id) {
      console.log("loadAllocationArea");
      const response = await AllocationAreaService.find({
        allocation: allocation_id,
      });
      console.log("response", response);
      const areas = response.data;
      console.log("areas", areas);

      this.blocks = [{}, {}, {}];
      for (let index = 0; index < areas.length; index++) {
        const area = areas[index];
        for (let no = 0; no < 3; no++) {
          if (this.blocks[no][area.block] === undefined) {
            this.blocks[no][area.block] = {
              type: area.type,
              no: [area.no],
              length: area.length,
              width: area.width,
              height: area.height,
              weight: area.weight,
            };
          } else {
            this.blocks[this.no][area.block].no.push(area.no);
          }
        }
      }
      console.log("blocks", this.blocks);
    },
    onExportLottery() {
      console.log("onExportLottery");
      console.log(this.lottery.normalizedEntries);
      console.log(this.blocks);
      let lines = [];
      let mainHeaders = [];
      let headers = [];
      const specLabels = [
        "name",
        "length",
        "width",
        "height",
        "weight",
        "totalWeight",
        "lowWeight",
        "own",
      ];
      for (let no = 0; no < this.lottery.normalizedEntries.length; no++) {
        const block = this.blocks[no];
        const keys = Object.keys(block);
        mainHeaders[no] = `${no + 1}台目`;
        headers[no] = `部屋番号,申込,${keys.join(
          ",",
        )},車種名称,全長,全幅,全高,重量,総重量,重量下限,購入,最終登録日`;
        const normalizedEntry = this.lottery.normalizedEntries[no];
        console.log("normalizedEntry=", no, normalizedEntry);
        lines[no] = [];
        // let isAddedHeader = false
        for (let index = 0; index < normalizedEntry.length; index++) {
          let str = "";
          const entry = normalizedEntry[index];
          console.log("++entry=", entry);
          str += `${entry.roomNo},${entry.entry ? "◯" : "-"},`;
          for (let index2 = 0; index2 < keys.length; index2++) {
            const key = keys[index2];
            str += `${entry[key] ? entry[key] : "-"},`;
          }
          if (entry.entry) {
            // const specLabels = Object.keys(entry.entry.spec)
            console.log("specLabels=", specLabels);
            let spec = entry.entry.spec;
            console.log("spec=", spec);
            spec = spec ? spec : "";
            console.log("-------");
            // if (!isAddedHeader) {
            //   isAddedHeader = true;
            //   headers[no] += `,${specLabels.join(",")}`;
            // }
            for (let index3 = 0; index3 < specLabels.length; index3++) {
              const specLabel = specLabels[index3];
              console.log("specLabel=", specLabel);
              str += `${spec[specLabel] ? spec[specLabel] : "-"},`;
            }
            console.log("-------");
            if (entry.entry["user_registered_date"]) {
              str += `${moment(entry.entry["user_registered_date"]).format(
                "YYYY-MM-DD HH:mm:ss",
              )},`;
            } else {
              str += ",";
            }
          }
          lines[no][index] = str;
        }
      }
      console.log("lines=", lines);
      console.log("mainHeaders=", mainHeaders);
      console.log("headers=", headers);
      let csv = "";
      for (let index = 0; index < mainHeaders.length; index++) {
        csv += `${mainHeaders[index]}\n`;
        csv += `${headers[index]}\n`;
        for (let index2 = 0; index2 < lines[index].length; index2++) {
          csv += `${lines[index][index2]}\n`;
        }
        csv += "\n";
      }
      console.log("csv=", csv);
      const filename = `申込状況_${moment().format("YYYYMMDD_HHmmss")}.csv`;
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      //Blobでデータを作成する
      const blob = new Blob([bom, csv], { type: "text/csv" });

      //IE10/11用(download属性が機能しないためmsSaveBlobを使用）
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, filename);
        //その他ブラウザ
      } else {
        //BlobからオブジェクトURLを作成する
        const url = (window.URL || window.webkitURL).createObjectURL(blob);
        //ダウンロード用にリンクを作成する
        const download = document.createElement("a");
        //リンク先に上記で生成したURLを指定する
        download.href = url;
        //download属性にファイル名を指定する
        download.download = filename;
        //作成したリンクをクリックしてダウンロードを実行する
        download.click();
        //createObjectURLで作成したオブジェクトURLを開放する
        (window.URL || window.webkitURL).revokeObjectURL(url);
      }
    },
  },
};
</script>

<style>
.last-lottery {
  margin-top: 10px;
  font-size: 14px;
  color: red;
}
</style>
